export function floatEquals(
  x: number | undefined | null,
  y: number | undefined | null
): boolean {
  if (!x || !y) {
    return false
  }
  return Math.abs(x - y) < Number.EPSILON
}
